import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import { List, ListSubheader } from '@mui/material';
import SKDGroupItem from './groupItem';
import itemTypes from '../itemTypes';
import { groupsPropType } from '../../hooks';
import GroupEditor, { useGroupEditor } from '../groupEditor';

function SKDGroupsList({
  groups, activeGroup, onClick, onDblClick, onDragEnd, onSubGroupClick, onChangeHierarchy, onSwapSubgroups,
}) {
  const [padded, setPadded] = useState(null);
  const onDragEndHandler = useCallback(
    (item) => {
      onDragEnd(item, padded);
    },
    [onDragEnd, padded],
  );
  const [{
    isOver, isOverCurrent, didDrop,
  }, ref] = useDrop({
    accept: [itemTypes.availableField, itemTypes.group],
    drop: (item) => onDragEndHandler(item),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
      // CanDrop: monitor.canDrop(),
      didDrop: monitor.didDrop(),
    }),
  });

  useEffect(() => {
    if ((!isOver && !isOverCurrent && !didDrop) || (isOver && isOverCurrent && !didDrop)) {
      setPadded(null);
    }
  }, [didDrop, isOver, isOverCurrent]);

  const {
    ctxMenu, ctxMenuopened, onCloseCtxMenu, onCtxMenu, onDeleteItem, editDialog, onEditItem,
    onCloseEditDialog, subItems, onRemoveSubGroup, onUpSubgroup, onDownSubgroup,
  } = useGroupEditor({
    onDelete: onDblClick, items: groups, onRemoveSubItem: onSubGroupClick, onSwap: onSwapSubgroups,
  });

  return (
    <List
      sx={{
        border: 1, borderColor: 'divider', borderRadius: 2, overflow: 'auto', flex: '1 1 auto', width: 50,
      }}
      ref={ref}
      component="nav"
      subheader={(
        <ListSubheader component="div" sx={{ bgcolor: 'grey.100' }}>
          Обрані групування
        </ListSubheader>
      )}
      dense
      disablePadding
    >
      {groups.map((f) => (
        <SKDGroupItem
          subgroups={f.items}
          name={f.name}
          key={f.name}
          onClick={onClick}
          onDblClick={onDblClick}
          onSubGroupClick={onSubGroupClick}
          active={activeGroup === f.name}
          onHover={setPadded}
          padded={padded === f.name}
          onChangeHierarchy={onChangeHierarchy}
          onCtxMenu={onCtxMenu}
        />
      ))}
      <GroupEditor
        onDeleteItem={onDeleteItem}
        ctxMenuopened={ctxMenuopened}
        ctxMenu={ctxMenu}
        onCloseCtxMenu={onCloseCtxMenu}
        editDialog={editDialog}
        onEditItem={onEditItem}
        onCloseEditDialog={onCloseEditDialog}
        subItems={subItems}
        onRemoveSubGroup={onRemoveSubGroup}
        onUpSubgroup={onUpSubgroup}
        onDownSubgroup={onDownSubgroup}
      />
    </List>
  );
}

SKDGroupsList.propTypes = {
  groups: groupsPropType.isRequired,
  onClick: PropTypes.func.isRequired,
  onSubGroupClick: PropTypes.func.isRequired,
  onDblClick: PropTypes.func.isRequired,
  activeGroup: PropTypes.string,
  onDragEnd: PropTypes.func.isRequired,
  onChangeHierarchy: PropTypes.func.isRequired,
  onSwapSubgroups: PropTypes.func.isRequired,
};

SKDGroupsList.defaultProps = {
  activeGroup: null,
};
export default SKDGroupsList;
